
  window.gwInitProductGallery = (root = document) => {
    const gallery = root.querySelector('[data-gw-universal-gallery]');
    if (!gallery || gallery.dataset.gwBound) return;
    gallery.dataset.gwBound = 'true';

    const track = gallery.querySelector('.gw-universal-product__track');
    const allThumbs = Array.from(gallery.querySelectorAll('[data-gw-universal-thumb]'));
    let thumbs = allThumbs.slice();
    const allSlides = Array.from(gallery.querySelectorAll('[data-gw-universal-open]'));
    let slides = allSlides.slice();
    const prev = gallery.querySelector('.gw-universal-product__arrow--prev');
    const next = gallery.querySelector('.gw-universal-product__arrow--next');
    const lightbox = root.querySelector('[data-gw-universal-lightbox]');
    const lightboxTrack = lightbox?.querySelector('.gw-universal-lightbox__track');
    const close = lightbox?.querySelector('[data-gw-universal-close]');
    const lightboxPrev = lightbox?.querySelector('[data-gw-universal-lightbox-prev]');
    const lightboxNext = lightbox?.querySelector('[data-gw-universal-lightbox-next]');
    const form = root.querySelector('[data-gw-universal-form]');
    const variantInput = form?.querySelector('[data-gw-universal-variant-input]');
    const sizeButtons = Array.from(form?.querySelectorAll('[data-gw-universal-variant]') || []);

    let index = 0;
    let lightboxIndex = 0;

    const setActive = (nextIndex) => {
      if (!slides.length || !track) return;
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle('is-active', thumbIndex === index);
      });
    };

    const setLightbox = (nextIndex) => {
      if (!slides.length || !lightboxTrack) return;
      lightboxIndex = (nextIndex + slides.length) % slides.length;
      lightboxTrack.style.transform = `translateX(-${lightboxIndex * 100}%)`;
    };

    const openLightbox = (startIndex) => {
      if (!lightbox || !lightboxTrack) return;
      lightboxTrack.replaceChildren(...slides.map((slide) => slide.querySelector('img')?.cloneNode(true)).filter(Boolean));
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        lightbox.setAttribute('open', '');
      }
      lightbox.focus({ preventScroll: true });
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      setLightbox(startIndex);
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') {
        lightbox.close();
      } else {
        lightbox.removeAttribute('open');
      }
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };


    const bindSwipe = (surface, getIndex, change) => {
      if (!surface) return;
      let start = null;
      let suppressClickUntil = 0;
      surface.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) { start = null; return; }
        start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      surface.addEventListener('touchcancel', () => { start = null; }, { passive: true });
      surface.addEventListener('touchend', (event) => {
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        start = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        suppressClickUntil = Date.now() + 500;
        change(getIndex() + (dx < 0 ? 1 : -1));
      }, { passive: true });
      surface.addEventListener('click', (event) => {
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    };
    bindSwipe(track, () => index, setActive);
    bindSwipe(lightboxTrack, () => lightboxIndex, setLightbox);

    allThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => setActive(thumbs.indexOf(thumb)));
    });
    allSlides.forEach(slide => {
      slide.addEventListener('click', () => openLightbox(slides.indexOf(slide)));
    });
    prev?.addEventListener('click', () => setActive(index - 1));
    next?.addEventListener('click', () => setActive(index + 1));
    close?.addEventListener('click', closeLightbox);
    lightboxPrev?.addEventListener('click', () => setLightbox(lightboxIndex - 1));
    lightboxNext?.addEventListener('click', () => setLightbox(lightboxIndex + 1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('close', () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
    document.addEventListener('keydown', (event) => {
      if (!lightbox?.open) return;
      if (event.key === 'ArrowLeft') setLightbox(lightboxIndex - 1);
      if (event.key === 'ArrowRight') setLightbox(lightboxIndex + 1);
    });


    const options = form?.querySelector('gw-product-options');
    const palette = [...new Set((options?.variants || []).map(v => v.colour))];
    let displayedColour = null;
    const applyColour = colour => {
      if (!colour || displayedColour === colour) return;
      displayedColour = colour;
      const matches = allSlides.map(slide => {
        const alt = slide.querySelector('img')?.alt || '';
        const tagged = palette.find(c => alt.endsWith(' – ' + c));
        return !tagged || tagged === colour;
      });
      allSlides.forEach((slide,i) => {slide.style.display = matches[i] ? '' : 'none';});
      allThumbs.forEach((thumb,i) => {thumb.style.display = matches[i] ? '' : 'none';});
      slides = allSlides.filter((slide,i) => matches[i]);
      thumbs = allThumbs.filter((thumb,i) => matches[i]);
      setActive(0);
    };
    form?.addEventListener('gw:variant:changed', event => applyColour(event.detail.colour));
    applyColour(options?.colour);

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled || !variantInput) return;
        variantInput.value = button.dataset.gwUniversalVariant;
        const price = root.querySelector("[data-gw-universal-price]");
        if (price) price.textContent = button.dataset.gwUniversalPrice;
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variantInput.value);
        window.history.replaceState({}, "", url);
        sizeButtons.forEach((sizeButton) => {
          const isActive = sizeButton === button;
          sizeButton.classList.toggle('is-active', isActive);
          sizeButton.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
      });
    });
  };
  window.gwInitProductGallery();
  document.addEventListener('gw:product:updated', event => window.gwInitProductGallery(event.detail.root));
